
import React from 'react';
import { INSTAGRAM_POSTS } from '../constants';
import { Instagram, ExternalLink } from 'lucide-react';

const SocialProof: React.FC = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[11px] uppercase tracking-[0.4em] text-brand-gold mb-4 block font-bold">
            Expérience Communautaire
          </span>
          <h2 className="font-serif text-3xl md:text-5xl">Porté par Vous</h2>
          <p className="mt-4 text-gray-400 font-light italic text-sm">Découvrez comment nos clientes s'approprient l'élégance Khamal.</p>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {INSTAGRAM_POSTS.map((post, idx) => (
            <a 
              key={idx} 
              href={post.url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="relative group overflow-hidden aspect-[4/5] bg-brand-cream block"
            >
              <img 
                src={post.image} 
                alt="Instagram Community Look" 
                className="w-full h-full object-cover luxury-transition group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-brand-black/40 opacity-0 group-hover:opacity-100 luxury-transition flex flex-col items-center justify-center p-4">
                <Instagram className="text-white mb-3" size={28} />
                <span className="text-white text-[9px] uppercase tracking-[0.2em] font-bold border border-white/30 px-3 py-2 flex items-center gap-2">
                  Voir sur Instagram <ExternalLink size={10} />
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a 
            href="https://www.instagram.com/khamal.bags/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] font-bold text-brand-black hover:text-brand-gold transition-all group"
          >
            Suivre @Khamal.Bags sur
            <Instagram size={16} className="group-hover:rotate-12 transition-transform" />
          </a>
        </div>  


        <div className="mt-16 text-center">
          <a 
            href="https://www.tiktok.com/@khamal.bags" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] font-bold text-brand-black hover:text-brand-gold transition-all group"
          >
            Suivre @Khamal.Bags sur
            <svg 
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="currentColor" 
              className="group-hover:rotate-12 transition-transform"
            >
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .8.11V9.4a6.33 6.33 0 0 0-1-.08A6.34 6.34 0 0 0 3 15.66a6.34 6.34 0 0 0 10.86 4.43 6.34 6.34 0 0 0 3.14-5.42V8.23a8.16 8.16 0 0 0 4.59 1.48V6.26a4.86 4.86 0 0 1-2-.45z"/>
            </svg>
          </a>
            
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
